"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview3_exports = {};
__export(GeodesPreview3_exports, {
  default: () => GeodesPreview3_default
});
module.exports = __toCommonJS(GeodesPreview3_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.1641 16.9102C16.1641 17.0924 16.099 17.2487 15.9688 17.3789C15.8385 17.5091 15.6823 17.5742 15.5 17.5742H5.5C5.31771 17.5742 5.16146 17.5091 5.03125 17.3789C4.90104 17.2487 4.83594 17.0924 4.83594 16.9102V7.75C4.83594 7.64583 4.85547 7.54818 4.89453 7.45703C4.94661 7.36589 5.01823 7.28776 5.10938 7.22266L10.1094 3.47266C10.2266 3.38151 10.3568 3.33594 10.5 3.33594C10.6432 3.33594 10.7734 3.38151 10.8906 3.47266L15.8906 7.22266C15.9818 7.28776 16.0469 7.36589 16.0859 7.45703C16.138 7.54818 16.1641 7.64583 16.1641 7.75V16.9102ZM4.50391 6.42188C4.29557 6.57812 4.13281 6.77344 4.01562 7.00781C3.89844 7.24219 3.83984 7.48958 3.83984 7.75V16.9102C3.83984 17.3789 4.0026 17.776 4.32812 18.1016C4.65365 18.4271 5.04427 18.5898 5.5 18.5898H15.5C15.9557 18.5898 16.3464 18.4271 16.6719 18.1016C16.9974 17.776 17.1602 17.3789 17.1602 16.9102V7.75C17.1602 7.48958 17.1016 7.24219 16.9844 7.00781C16.8672 6.77344 16.7044 6.57812 16.4961 6.42188L11.4961 2.67188C11.1966 2.45052 10.8646 2.33984 10.5 2.33984C10.1354 2.33984 9.80339 2.45052 9.50391 2.67188L4.50391 6.42188ZM12.4922 15.25H14.3086L11.5156 7.75H9.58203L6.75 15.25H8.50781L9.05469 13.7266H11.9453L12.4922 15.25ZM10.5195 9.60547L11.418 12.2031H9.60156L10.5195 9.60547Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview3 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview3_default = SvgGeodesPreview3;
